import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import { Button, Typography } from '@mui/material';
import CustomisedButton from '../../common/components/CustomisedButton';

const useStyles = makeStyles({
    customRowStyling: {

    },
});
export default function DataGridTable(props) {
    const classes = useStyles()
    const routeToCompanyData = () => {
        window.location.href = '/companyWall'
    }
    return (
        <Box className={classes.customRowStyling} sx={{ height: 'fit-content', width: `${props.width}`, borderRadius: '10px',padding:'30px' }}>
            {props.isOngoingDeal ? <></> :
                <Box style={{ display: 'flex', justifyContent: 'space-between', padding: '1px' }}>
                    <Typography variant='h6' sx={{ color: 'white' }}>Company Wall</Typography>
                    <Button sx={{
                        width: "100px",
                        height: "35px",
                        color: "black",
                        borderColor: "white",
                        backgroundColor: "white",
                        borderRadius: "0.5rem",
                        "&:hover": {
                            borderColor: "white",
                            backgroundColor: "white"
                        },
                    }} variant='contained' onClick={routeToCompanyData}>Add More</Button>

                </Box>
            }

            <DataGrid
                className={classes.customRowStyling}
                getRowId={(row) => row._id}
                pageSizeOptions={[5,10]}
                sx={{
                    '& .MuiDataGrid-colCell': {
                        borderTop: '1px solid #ccc', // Add a top border to header cells
                    },
                    '& .MuiDataGrid-row': {
                        pointerEvents: 'none', // Disable pointer events for rows
                      },
                    '& .MuiTablePagination-toolbar': {
                        alignItems:"baseline",
                        color:"white"
                      },
                    fontSize: '14px',
                    backgroundColor: "#212121",
                    color: 'white',
                    border: 'none'
                }}

                rows={props.data}
                // autoHeight
                columns={props.columns}
                checkboxSelection={props?.checkBoxEnabled ? true : false}
                // pagination={false}
                hideFooter
                initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: props.pageSize,
                      },
                    },
                  }}
                // initialState={{
                //     filter: {
                //         filterModel: {
                //             items: [
                //                 {
                //                     columnField: 'rating',
                //                     operatorValue: '>',
                //                     value: '2.5',
                //                 },
                //             ],
                //         },
                //     },
                // }}
                autoHeight={true}
                rowCount={props.rowCount}
                paginationMode="server"
                onPaginationModelChange={props?.onPageChange}
                // disableColumnMenu
                // disableSelectionOnClick
                // experimentalFeatures={{ newEditingApi: true }}
            />
        </Box>
    )
}